<template>
  <div>
    <div container>
      <div grid="row wrap" column="12">
        <div v-html="group_info_header_html"></div>
      </div>
      <div grid="row wrap" v-if="value.userMessage.length !==0 ">
        <ul>
          <li v-for="item in value.userMessage" >
            <p class="lips validation">{{ item}} </p>
          </li>
        </ul>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="6">
          <app-input
            ref="businessName"
            :errorMessage="businessNameError"
            :invalid="$v.internalValue.businessName.$invalid"
            :required="false"
            label="Group Display Name:"
            v-model="$v.internalValue.businessName.$model"
            valueKey="businessName"
            @input="[escapeGroupName() , emitGroupInformation()]"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-select
            :errorMessage="typeOfBusinessError"
            :invalid="$v.internalValue.typeOfBusiness.$invalid"
            :options="businessTypeOptions"
            :required='false'
            @change='typeOfBusinessChanged'
            label='Type Of Business:'
            v-model="$v.internalValue.typeOfBusiness.$model"
            valueKey='typeOfBusiness'
            @input="emitGroupInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :disabled='specifyIfOtherDisabled'
            :errorMessage="specifyIfOtherError"
            :hidden="specifyIfOtherDisabled"
            :invalid="$v.internalValue.groupOther.$invalid"
            :required="false"
            label="Specify If Other:"
            v-model="$v.internalValue.groupOther.$model"
            valueKey="groupOther"
            @input="emitGroupInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="2">
          <app-input
            :errorMessage="businessTaxIDError"
            :invalid="$v.internalValue.businessTaxID.$invalid"
            :required="false"
            label="Tax ID#:"
            v-model="$v.internalValue.businessTaxID.$model"
            valueKey="businessTaxID"
            maxlength="10"
            :pattern="[0-9]"
            @input="[formatTaxId(),emitGroupInformation()]"
          />
        </div>
        <div class="_mtxs" column="4">
          <app-input
            :errorMessage="businessAddressLine1Error"
            :invalid="$v.internalValue.businessAddressLine1.$invalid"
            :required="false"
            label="Business Address Line 1:"
            v-model="$v.internalValue.businessAddressLine1.$model"
            valueKey="businessAddressLine1"
            @input="emitGroupInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="businessAddressLine2Error"
            :invalid="$v.internalValue.businessAddressLine2.$invalid"
            :required="false"
            label="Business Address Line 2:"
            v-model="$v.internalValue.businessAddressLine2.$model"
            valueKey="businessAddressLine2"
            @input="emitGroupInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="zipError"
            :invalid="$v.internalValue.businessZipCode.$invalid"
            :required="false"
            label="Business Zip Code:"
            pattern="[0-9]"
            type="number"
            v-model="$v.internalValue.businessZipCode.$model"
            valueKey="businessZipCode"
            @input="zipCodeUpdated"
          />
        </div>
      </div>
      <div grid="row wrap">
        <div class="_mtxs" column="4">
          <app-input
            :errorMessage="businessCityError"
            :invalid="$v.internalValue.businessCity.$invalid"
            :required="false"
            label="Business City:"
            v-model="$v.internalValue.businessCity.$model"
            valueKey="businessCity"
            @input="emitGroupInformation()"
          />
        </div>
        <div class="_mtxs" column="2">
          <app-labeled-data
            :data="internalValue.businessState.text"
            label="Business State:"
          />
        </div>
        <div class="_mtxs" column="6">
          <app-select
            :errorMessage="serviceAreaError"
            :invalid="$v.internalValue.serviceArea.$invalid"
            :options="serviceAreaOptions"
            :required='false'
            @change='serviceAreaChanged'
            label='Service Area:'
            v-model="$v.internalValue.serviceArea.$model"
            valueKey='serviceArea'
            @input="emitGroupInformation()"
          />
        </div>
      </div>
      <div :hidden="serviceAreaStateDisabled">
        <div class="card _mbxs" grid="row wrap">
          <div class="_mtxs" column="12">
            <p>If any subsidiary or affiliated companies are to be insured or any Employees/Members are working at a
              location other than the business address above, please list states:</p>
          </div>
          <div class="_mtxs" column="6" style="padding-left:10px;padding-bottom:10px">
            <app-auto-complete-input
              :hidden="serviceAreaStateDisabled"
              :on-key-up="onKeyUpAutoCompleteEvent"
              :on-selected="onSelectedAutoCompleteEvent"
              :result-items="autoCompleteStateResult"
              item-id="value"
              item-text="text"
              :invalid="serviceAreaStateRequired"
              :errorMessage="'Required'"
              placeHolderText="Click Here To Search And Select State(s)"
            />
            <div>
              <a @click="addAllStates()" class="leaf" style="padding-left:10px;padding-bottom:10px">Add all States</a>
              <a @click="removeAllStates()" class="leaf" style="padding-left:40px;padding-bottom:10px">Remove all States</a>
            </div>
          </div>
          <div class="_mtxs" column="12" v-if="internalValue.selectedStateFields.length >0">
            Selected States (Click a State to Remove it)
            <hr class="_mbxs _mts">
          </div>
          <div style="padding:5px;margin-top:30px;padding-left:15px" v-for="field in internalValue.selectedStateFields">
            <async-button :id="field.value" @clicked="removeState($event,field.value)" class="value-item"
                          style="width:180px;height:35px;padding:0px">
              <span style="font-size:13px;">{{field.text}}</span>
            </async-button>
          </div>
        </div>
        </div>
        <div class="card _mbxs" grid="row wrap">

      </div>

      <div grid="row wrap">
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="primaryContactFirstNameError"
            :invalid="$v.internalValue.primaryContactFirstName.$invalid"
            :required="false"
            label="Primary Contact First Name:"
            v-model="$v.internalValue.primaryContactFirstName.$model"
            valueKey="primaryContactFirstName"
            @input="emitGroupInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="primaryContactLastNameError"
            :invalid="$v.internalValue.primaryContactLastName.$invalid"
            :required="false"
            label="Primary Contact Last Name:"
            v-model="$v.internalValue.primaryContactLastName.$model"
            valueKey="primaryContactLastName"
            @input="emitGroupInformation()"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="primaryContactPhoneError"
            :invalid="$v.internalValue.primaryContactPhone.$invalid"
            :required="false"
            label="Primary Contact Phone:"
            v-model="$v.internalValue.primaryContactPhone.$model"
            valueKey="primaryContactPhone"
            maxlength="12"
            :pattern="[0-9]"
            @input="[formatPrimaryContactPhone(),emitGroupInformation()]"
          />
        </div>
        <div class="_mtxs" column="3">
          <app-input
            :errorMessage="primaryContactEmailError"
            :invalid="$v.internalValue.primaryContactEmail.$invalid"
            :required="false"
            label="Primary Contact Email:"
            v-model="$v.internalValue.primaryContactEmail.$model"
            valueKey="primaryContactEmail"
            @input="emitGroupInformation()"
          />
        </div>
      </div>
      <div grid="row wrap">
        <button
          @click="saveGroupInformation()" class="btn --sm _mtxs"
          column="12"
          :disabled="$v.$invalid || serviceAreaStateRequired || this.hasTitleSectionError"
        >
          Continue
        </button>
      </div>
      <div>
        <hr class="_mbxs _mts">
      </div>
    </div>
  </div>
</template>

<script>
  import AppAutoCompleteInput from '@atoms/AutoCompleteInput'
  import AppInput from '@atoms/Input'
  import AppSelect from '@atoms/Select'
  import AppLabeledData from '@molecules/LabeledData'
  import AsyncButton from '@molecules/AsyncButton'
  import newClientStateOptions from '@mixins/clientOnboardSelectOptions'
  import ZipCodeHelper from '@mixins/ZipCodeHelper'
  import formReady from '@mixins/formReady'
  import clientOnboardVerbiage from '@mixins/clientOnboardVerbiage'
  import { eventBus } from '@/main'

  import { email, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators'
  import {
    fiveDigitsLong, tenDigitsLong, twelveDigitsLong,
    formatPhone, formatTaxId, escapeGroupName
  } from '@/utils'

  export default {
    mixins: [
      formReady,
      ZipCodeHelper,
      newClientStateOptions,
      clientOnboardVerbiage
    ],
    components: {
      AppInput,
      AppAutoCompleteInput,
      AppSelect,
      AppLabeledData,
      AsyncButton
    },
    props: {
      value: {
        type: Object
      }
    },
    data() {
      return {
        isLastSigner: this.value.groupInfoValues.isLastSigner,
        autoCompleteStateResult: [],
        specifyIfOtherDisabled: true,
        serviceAreaStateDisabled: true,
        serviceAreaStateRequired: false,
        hasTitleSectionError: this.value.groupInfoValues.hasTitleSectionError,
        internalValue: {
          businessName: this.value.groupInfoValues.businessName || '',
          typeOfBusiness: this.value.groupInfoValues.typeOfBusiness || '',
          groupOther: this.value.groupInfoValues.groupOther || '',
          businessTaxID: this.value.groupInfoValues.businessTaxID || '',
          businessAddressLine1: this.value.groupInfoValues.businessAddressLine1 || '',
          businessAddressLine2: this.value.groupInfoValues.businessAddressLine2 || '',
          businessCity: this.value.groupInfoValues.businessCity || '',
          serviceArea: this.value.groupInfoValues.serviceArea || '',
          primaryContactFirstName: this.value.groupInfoValues.primaryContactFirstName || '',
          primaryContactLastName: this.value.groupInfoValues.primaryContactLastName || '',
          primaryContactPhone: this.value.groupInfoValues.primaryContactPhone || '',
          primaryContactEmail: this.value.groupInfoValues.primaryContactEmail || '',
          businessZipCode: this.value.groupInfoValues.businessZipCode || '',
          businessState: this.value.groupInfoValues.businessState || '',
          searchStates: this.value.groupInfoValues.searchStates || '',
          selectedStateFields: this.value.groupInfoValues.selectedStateFields || []
        }
      }
    },
    validations: {
      internalValue: {
        businessName: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(38)
        },
        typeOfBusiness: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        groupOther: {
          required: requiredIf(function () {
            return this.internalValue.typeOfBusiness === 'OT'
          }),
          maxLength: maxLength(20)
        },
        businessTaxID: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          tenDigitsLong
        },
        businessAddressLine1: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(40)
        },
        businessAddressLine2: {
          maxLength: maxLength(40)
        },
        businessCity: {
          maxLength: maxLength(19),
          required: requiredIf(function () {
            return this.isLastSigner
          })
        },
        businessZipCode: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          numeric,
          fiveDigitsLong
        },
        primaryContactFirstName: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(27)
        },
        primaryContactLastName: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          maxLength: maxLength(27)
        },
        primaryContactPhone: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          twelveDigitsLong
        },
        primaryContactEmail: {
          required: requiredIf(function () {
            return this.isLastSigner
          }),
          email,
          maxLength: maxLength(77)
        },
        serviceArea: {
          required: requiredIf(function () {
            return this.isLastSigner
          })
        }
      }
    },
    computed: {
      businessNameError() {
        if (!this.$v.internalValue.businessName.required) {
          return 'required'
        } else if (!this.$v.internalValue.businessName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      typeOfBusinessError() {
        if (!this.$v.internalValue.typeOfBusiness.required) {
          return 'required'
        }
        return null
      },
      specifyIfOtherError() {
        if (!this.$v.internalValue.groupOther.required) {
          return 'Required'
        } else if (!this.$v.internalValue.groupOther.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      businessTaxIDError() {
        if (!this.$v.internalValue.businessTaxID.required) {
          return 'required'
        } else if (!this.$v.internalValue.businessTaxID.tenDigitsLong) {
          return '9 digits long'
        }
        return null
      },
      businessAddressLine1Error() {
        if (!this.$v.internalValue.businessAddressLine1.required) {
          return 'required'
        } else if (!this.$v.internalValue.businessAddressLine1.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      businessAddressLine2Error() {
        if (!this.$v.internalValue.businessAddressLine2.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      businessCityError() {
        if (!this.$v.internalValue.businessCity.required) {
          return 'required'
        } else if (!this.$v.internalValue.businessCity.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      zipError() {
        if (!this.$v.internalValue.businessZipCode.required) {
          return 'required'
        }

        let hasValue = this.$v.internalValue.businessZipCode.$model
        if (hasValue && (this.$v.internalValue.businessZipCode.$dirty || this.$v.internalValue.businessZipCode.$model.length !== 0)) {
          if (!this.$v.internalValue.businessZipCode.numeric) {
            return 'must be numeric'
          } else if (!this.$v.internalValue.businessZipCode.fiveDigitsLong) {
            return '5 digits long'
          }
        }
        return null
      },
      serviceAreaError() {
        if (!this.$v.internalValue.serviceArea.required) {
          return 'required'
        }
        return null
      },
      primaryContactFirstNameError() {
        if (!this.$v.internalValue.primaryContactFirstName.required) {
          return 'required'
        } else if (!this.$v.internalValue.primaryContactFirstName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      primaryContactLastNameError() {
        if (!this.$v.internalValue.primaryContactLastName.required) {
          return 'required'
        } else if (!this.$v.internalValue.primaryContactLastName.maxLength) {
          return 'character limit exceeded'
        }
        return null
      },
      primaryContactPhoneError() {
        if (!this.$v.internalValue.primaryContactPhone.required) {
          return 'required'
        } else if (!this.$v.internalValue.primaryContactPhone.twelveDigitsLong) {
          return '10 digits long'
        }
        return null
      },
      primaryContactEmailError() {
        if (!this.$v.internalValue.primaryContactEmail.required) {
          return 'required'
        } else if (!this.$v.internalValue.primaryContactEmail.maxLength) {
          return 'character limit exceeded'
        } else if (!this.$v.internalValue.primaryContactEmail.email) {
          return 'Not a valid email address'
        }
        return null
      }
    },
    methods: {
      formatPrimaryContactPhone() {
        this.internalValue.primaryContactPhone = formatPhone(this.internalValue.primaryContactPhone)
      },
      formatTaxId() {
        this.internalValue.businessTaxID = formatTaxId(this.internalValue.businessTaxID)
      },
      escapeGroupName() {
        this.internalValue.businessName = escapeGroupName(this.internalValue.businessName)
      },
      typeOfBusinessChanged() {
        this.specifyIfOtherDisabled = this.internalValue.typeOfBusiness !== 'OT'
        if (this.specifyIfOtherDisabled) {
          this.internalValue.groupOther = ''
        }
      },
      serviceAreaChanged() {
        this.serviceAreaStateDisabled = this.internalValue.serviceArea !== 'SS'
        if (this.serviceAreaStateDisabled) {
          this.removeAllStates()
        }
        this.setServiceAreaStateRequired()
      },

      zipCodeUpdated() {
        this.internalValue.businessCity = ''
        if (this.$v.internalValue.businessZipCode.$invalid || this.internalValue.businessZipCode === '') {
          this.emitGroupInformation()
          return
        }
        this.suggestLocationFromPublicUtilZipCode(this.internalValue.businessZipCode)
          .then((suggestion) => {
            if (!suggestion) {
              this.emitGroupInformation()
              return
            }
            if (suggestion.city) {
              this.internalValue.businessCity = suggestion.city
              this.emitGroupInformation()
            }
          })
      },
      isFormValid() {
        this.$v.$touch()
        return !this.$v.$error
      },
      saveGroupInformation() {
        if (this.isFormValid()) {
          this.$emit('continue', this.internalValue)
        }
      },
      emitGroupInformation() {
        this.$emit('groupInfoUpdated', this.internalValue)
      },

      onSelectedAutoCompleteEvent(id, text) {
        this.autoCompleteStateResult = []
        let valObj = false
        this.internalValue.selectedStateFields.filter(function (elem) {
          if (elem.value === id) valObj = true
        })

        if (!valObj) {
          this.internalValue.selectedStateFields.push({ value: id, text: text })
        }
        this.setServiceAreaStateRequired()
        this.emitGroupInformation()
      },
      onKeyUpAutoCompleteEvent(keywordEntered) {
        this.autoCompleteStateResult = []
        if (keywordEntered.length > 0) {
          this.newClientStateOptions.forEach(item => {
            if (item.text.toLowerCase().startsWith(keywordEntered.toLowerCase())) {
              this.autoCompleteStateResult.push(item)
            }
          })
        }
        this.setServiceAreaStateRequired()
        this.emitGroupInformation()
      },
      addAllStates() {
        if (!this.serviceAreaStateDisabled) {
          this.internalValue.selectedStateFields = []
          this.newClientStateOptions.forEach(state => {
            this.internalValue.selectedStateFields.push({ value: state.value, text: state.text })
          })
        }
        this.setServiceAreaStateRequired()
        this.emitGroupInformation()
      },
      removeState(clicked, id) {
        if (clicked) {
          let index = this.internalValue.selectedStateFields.findIndex((f) => f.value === id)
          this.$delete(this.internalValue.selectedStateFields, index)
        }
        this.setServiceAreaStateRequired()
        this.emitGroupInformation()
      },
      removeAllStates() {
        this.newClientStateOptions.forEach(item => {
          let index = this.internalValue.selectedStateFields.findIndex((f) => f.value === item.value)
          if (index !== -1) {
            this.$delete(this.internalValue.selectedStateFields, index)
          }
        })
        this.setServiceAreaStateRequired()
        this.emitGroupInformation()
      },
      setServiceAreaStateRequired() {
        this.serviceAreaStateRequired = this.internalValue.selectedStateFields.length === 0 && !this.serviceAreaStateDisabled
      }
    },
    created() {
      eventBus.$on('groupTitleSectionHasError', (data) => {
        this.hasTitleSectionError = data
      })
    },
    mounted() {
      this.$refs.businessName.$el.children[1].focus()
      this.typeOfBusinessChanged()
      this.serviceAreaChanged()
    },
    watch: {
      internalValue: {
        deep: true,
        handler() {
          this.$emit('valueChanged', true)
        }
      }
    }
  }
</script>
